import cs from 'vuetify/es5/locale/cs';
import icons from '@/components/Atoms/Icons/index';
import colors from '@/assets/js/colors.js';

export default {
  breakpoint: {
    thresholds: {
      xs: 576,
      sm: 784, // 768 + 16 - top hranica SM
      md: 1008, // 992 + 16 - top hranica MD
      lg: 1200
    }
  },
  icons: {
    values: icons
  },
  lang: {
    locales: { cs },
    current: 'cs'
  },
  theme: {
    themes: {
      light: {
        // definition of {color}--text classes and color="{color}" attributes
        ...colors,
        primary: colors['brand'],
        secondary: colors['brand-lighten']
      }
    }
  }
};
